module.exports = __webpack_public_path__ + "img/forever-manchester-logo.0693a4ae.svg";